import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "survey_form" }
const _hoisted_2 = { class: "survey_progress" }
const _hoisted_3 = { class: "count" }
const _hoisted_4 = { class: "bar" }
const _hoisted_5 = {
  key: 0,
  class: "survey_content",
  style: {"display":"block"}
}
const _hoisted_6 = { class: "survey_tit" }
const _hoisted_7 = {
  key: 1,
  class: "check_list",
  style: {"display":"block"}
}
const _hoisted_8 = ["name", "value", "onChange"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "check_list"
}
const _hoisted_11 = ["name", "value", "onChange"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, null, -1)
const _hoisted_13 = { class: "survey_check_box" }
const _hoisted_14 = { class: "check_circle" }
const _hoisted_15 = ["name", "value", "onChange"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "survey_check_txt" }, [
  /*#__PURE__*/_createElementVNode("span", null, "스트레스 전혀 없음"),
  /*#__PURE__*/_createElementVNode("span", null, "극심한 스트레스")
], -1)
const _hoisted_17 = {
  class: "survey_btns",
  style: {"gap":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_surveyModal = _resolveComponent("surveyModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "percent",
          style: _normalizeStyle(`left:${($setup.result.currentPage + 1) / $setup.props.data.length * 100}%`)
        }, [
          _createElementVNode("span", null, _toDisplayString($setup.floatFormat(($setup.result.currentPage + 1) / $setup.props.data.length * 100)) + "%", 1)
        ], 4),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, [
            _createElementVNode("b", null, _toDisplayString($setup.result.currentPage + 1), 1),
            _createTextVNode("/ " + _toDisplayString($setup.props.data.length), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.data.length, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass($setup.result.currentPage + 1 >= item ? 'full' : '')
            }, null, 2))
          }), 256))
        ])
      ]),
      ($setup.result.currentPage < $setup.props.data.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _createElementVNode("b", null, _toDisplayString($setup.result.currentPage + 1) + ".", 1),
              _createTextVNode(" " + _toDisplayString($setup.currentQuestion.title), 1)
            ]),
            ($setup.currentQuestion.type === 1)
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 0,
                  onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectAnswer($setup.currentQuestion.idx, 0, $setup.result.answer))),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.result.answer) = $event)),
                  class: "survey_text",
                  placeholder: "내 답변"
                }, null, 544)), [
                  [_vModelText, $setup.result.answer]
                ])
              : _createCommentVNode("", true),
            ($setup.currentQuestion.type === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentQuestion.choiceList, (option, optIndex) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: "radio",
                      key: optIndex
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: 'question' + $setup.currentQuestion.idx,
                        value: option.idx,
                        onChange: ($event: any) => ($setup.selectAnswer($setup.currentQuestion.idx, option.idx)),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.result.selectRadio) = $event))
                      }, null, 40, _hoisted_8), [
                        [_vModelRadio, $setup.result.selectRadio]
                      ]),
                      _hoisted_9,
                      _createElementVNode("span", null, _toDisplayString(option.title), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            ($setup.currentQuestion.type === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentQuestion.choiceList, (option, optIndex) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: "checkbox",
                      key: optIndex
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: 'question' + $setup.currentQuestion.idx,
                        value: option.idx,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.result.selectCheckBox) = $event)),
                        onChange: ($event: any) => ($setup.selectAnswerCheckBox($setup.currentQuestion.idx, option.idx))
                      }, null, 40, _hoisted_11), [
                        [_vModelCheckbox, $setup.result.selectCheckBox]
                      ]),
                      _hoisted_12,
                      _createElementVNode("span", null, _toDisplayString(option.title), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            ($setup.currentQuestion.type === 4)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentQuestion.choiceList, (option, optIndex) => {
                        return (_openBlock(), _createElementBlock("label", {
                          class: "checkbox",
                          key: optIndex
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: 'question' + $setup.currentQuestion.idx,
                            value: option.idx,
                            onChange: ($event: any) => ($setup.selectAnswer($setup.currentQuestion.idx, option.idx)),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.result.selectRadio) = $event))
                          }, null, 40, _hoisted_15), [
                            [_vModelRadio, $setup.result.selectRadio]
                          ]),
                          _createElementVNode("span", null, _toDisplayString(optIndex), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _hoisted_16
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              ($setup.result.currentPage !== 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn_blue",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.prevQuestion && $setup.prevQuestion(...args)))
                  }, " 이전 "))
                : _createCommentVNode("", true),
              ($setup.result.currentPage !== $setup.props.data.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn_blue",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.nextQuestion && $setup.nextQuestion(...args)))
                  }, " 다음 "))
                : _createCommentVNode("", true),
              ($setup.result.currentPage === $setup.props.data.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn_blue",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkSurvey()))
                  }, "제출"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_surveyModal, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}